// extracted by mini-css-extract-plugin
export default {"wrapper":"NotFound_wrapper__pmQK5","btn":"NotFound_btn__LNjlp"};